/* unplugin-vue-components disabled *//* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Rater from "vux/src/components/rater/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Previewer from "vux/src/components/previewer/index.vue"; // this line is trasformed by vux-loader
import { apicustomereval } from '@/api';
import ExtField from '@/components/ExtField';
export default {
  name: 'CustomerEvaluate',
  props: {
    oid: String,
    orderInfo: Object,
    orderExtFields: Array
  },
  directives: {
    // 指令
    TransferDom: TransferDom
  },
  components: {
    ViewBox: ViewBox,
    Rater: Rater,
    Previewer: Previewer,
    ExtField: ExtField
  },
  data: function data() {
    return {
      evaluatePicList: [],
      orderMap: {},
      evalpic: '',
      extFields: [],
      list: [],
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          if (thumbnail) {
            var _thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (_thumbnail.getBoundingClientRect) {
              var rect = _thumbnail.getBoundingClientRect();
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          }
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    isProduction: function isProduction() {
      return process.env.NODE_ENV === 'production';
    }
  }),
  methods: {
    reload: function reload() {
      var _this = this;
      apicustomereval({
        oid: this.oid
      }).then(function (res) {
        if (res.success) {
          _this.orderMap = res.data.orderMap;
          _this.evaluatePicList = res.data.image_descri_list;
          _this.extFields = res.data.list || [];
        }
      });
    },
    show: function show(index) {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.$refs.previewer.show(index);
      });
    }
  },
  created: function created() {
    this.reload();
  }
};